// blakfy-cookie/src/presets/google-maps.js — Google Maps preset (functional category)

export default {
  name: "Google Maps",
  category: "functional",
  cookies: [],
  storage: [],
  scriptHosts: ["maps.googleapis.com", "maps.gstatic.com"],
  onGrant: (state) => {},
  onRevoke: (state) => {},
};
